import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { RefreshCw } from 'lucide-react';

/**
 * UpdatePrompt - Zorunlu güncelleme bildirimi
 * Dismiss edilemez, 5 saniye sonra otomatik güncellenir
 */
export default function UpdatePrompt({ onUpdate }) {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown <= 0) {
      onUpdate();
      return;
    }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, onUpdate]);

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9999] flex items-center justify-center p-4" style={{ animation: 'oxFadeIn .15s ease' }}>
      <div
        className="rounded-xl shadow-2xl p-6 max-w-sm w-full text-center"
        style={{ background: 'var(--surface)', border: '1px solid var(--border)', color: 'var(--text)', animation: 'oxSlideUp .2s cubic-bezier(.2,.8,.2,1)' }}
      >
        <div
          className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
          style={{ background: 'var(--accent-weak)' }}
        >
          <RefreshCw className="w-7 h-7 animate-spin" style={{ color: 'var(--accent)' }} />
        </div>

        <h3 className="font-bold text-lg mb-2" style={{ color: 'var(--text)' }}>
          Yeni Güncelleme Mevcut
        </h3>
        <p className="text-sm mb-4 ox-text-muted">
          OnxFlow güncellendi. En iyi deneyim için uygulama yeniden yüklenecek.
        </p>
        
        <Button
          onClick={onUpdate}
          className="w-full"
          data-testid="force-update-button"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Şimdi Güncelle ({countdown}s)
        </Button>
      </div>
    </div>
  );
}
